var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isRiv)?_c('div',{staticClass:"logo-container w-100"},[_c('div',{staticClass:"mx-auto",attrs:{"id":"reseller-icon"}})]):(_vm.logoSrc)?_c('b-img',{attrs:{"src":_vm.logoSrc,"center":true,"alt":"logo","width":_vm.logoWidth}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }